import { useRepositoryMutation } from '@mews-commander/data-access';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Button, Dialog } from '@optimus-web/core';

export interface SsoStatusDialogProps {
    active: boolean;
    onClose: () => void;
    isSsoEnabled: boolean;
}

export function SsoStatusDialog({ isSsoEnabled, onClose, active }: SsoStatusDialogProps) {
    const { mutate, isPending } = useRepositoryMutation('ssoConnection', 'updateConnectionStatus', {
        onSuccess: onClose,
        invalidateQueries: {
            ssoConnection: ['get', 'getOpenId'],
            securityOverview: ['getOverview'],
        },
    });

    const contentMap = {
        enableSso: {
            title: <LocalizedText textKey={TextKey.SsoEnableDialogTitle} />,
            content: <LocalizedText textKey={TextKey.SsoEnableDialogContent} />,
            confirmButton: (
                <Button
                    size="small"
                    variant="primary"
                    onClick={() => mutate({ isEnabled: true })}
                    loading={isPending}
                    type="submit"
                >
                    <LocalizedText textKey={TextKey.Activate} />
                </Button>
            ),
        },
        disableSso: {
            title: <LocalizedText textKey={TextKey.SsoDisableDialogTitle} />,
            content: <LocalizedText textKey={TextKey.SsoDisableDialogContent} />,
            confirmButton: (
                <Button
                    size="small"
                    variant="primary"
                    onClick={() => mutate({ isEnabled: false })}
                    loading={isPending}
                    type="submit"
                >
                    <LocalizedText textKey={TextKey.Deactivate} />
                </Button>
            ),
        },
    };

    const dialogContent = isSsoEnabled ? contentMap.disableSso : contentMap.enableSso;

    return (
        <Dialog
            active={active}
            onClose={onClose}
            title={dialogContent.title}
            footer={{
                primary: dialogContent.confirmButton,
                secondary: (
                    <Button size="small" variant="tertiary" onClick={onClose} type="submit">
                        <LocalizedText textKey={TextKey.GoBack} />
                    </Button>
                ),
            }}
        >
            {dialogContent.content}
        </Dialog>
    );
}
